import React from 'react';
import { Inbox, Clock, Globe, Package, TrendingUp, Flame, BookOpen, MapPin, Search, FileText, Image, Star } from 'lucide-react';

export function AdminStats({ stats, views }) {
  const cards = [
    { icon: Inbox, label: 'Total Inquiries', value: stats.total, color: '#D4870A' },
    { icon: Clock, label: 'New / Pending', value: stats.new, color: '#3B82F6' },
    { icon: Flame, label: 'Hot Leads', value: stats.hot, color: '#EF4444' },
    { icon: Globe, label: 'Countries', value: stats.countries, color: '#6B8E23' },
    { icon: Package, label: 'Products', value: stats.products, color: '#E8A020' },
    { icon: TrendingUp, label: 'Views (30d)', value: views ?? '—', color: '#8B7355' },
  ];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {cards.map(stat => (
        <div key={stat.label} className="bg-white rounded-lg p-4 border border-saffron-100/50 shadow-card-lift" data-testid={`stat-${stat.label}`}>
          <div className="w-8 h-8 rounded-lg flex items-center justify-center mb-2" style={{ backgroundColor: stat.color + '15' }}>
            <stat.icon size={16} style={{ color: stat.color }} />
          </div>
          <p className="font-display text-2xl font-bold text-earth-dark">{stat.value}</p>
          <p className="text-[10px] text-earth/50 font-sans">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}

const TABS = [
  { key: 'inquiries', label: 'Inquiries', icon: Inbox },
  { key: 'products', label: 'Products', icon: Package },
  { key: 'blog', label: 'Blog', icon: BookOpen },
  { key: 'landing-pages', label: 'Landing Pages', icon: MapPin },
  { key: 'seo', label: 'SEO & Redirects', icon: Search },
  { key: 'certificates', label: 'Certificates', icon: FileText },
  { key: 'site-photos', label: 'Site Photos', icon: Image },
  { key: 'testimonials', label: 'Testimonials', icon: Star },
  { key: 'analytics', label: 'Analytics', icon: TrendingUp },
];

export function AdminTabs({ active, counts, onChange }) {
  return (
    <div className="flex flex-wrap gap-2 mb-6 border-b border-earth/10 pb-3" data-testid="admin-tabs">
      {TABS.map(t => {
        const count = counts[t.key] || 0;
        const isActive = active === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            className={`flex items-center gap-2 px-5 py-2.5 text-sm font-sans font-medium rounded-md transition-colors whitespace-nowrap ${isActive ? 'bg-saffron text-white' : 'bg-white text-earth/60 border border-earth/15 hover:border-saffron/30'}`}
            data-testid={`tab-${t.key}`}
          >
            <t.icon size={14} /> {t.label}
            {count > 0 && <span className={`text-[10px] px-1.5 py-0.5 rounded ${isActive ? 'bg-white/20' : 'bg-saffron/10 text-saffron'}`}>{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
